<template lang="pug">
.date-picker-component
    label.input-label-date {{ label }}
    .date-picker-container(
        :class='prefix ? "date-picker-container-prefix" : ""'
    )
        .date-picker-prefix(v-if='prefix') {{ prefix }}
        input.date-picker-input(
            :id='id',
            type='date',
            :value='value',
            @input='$emit("input", $event.target.value)'
        )
</template>

<script>
export default {
    name: 'DatePickerComponent',
    props: {
        value: {},
        id: {
            type: String,
            default: () => `date-input-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },

        prefix: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.date-picker-component {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
}

.date-picker-container {
    display: flex;
    flex-direction: row;
    margin: 5px 0 10px 0;
    width: 100% !important;

    &.date-picker-container-prefix {
        .date-picker-input {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
        }
    }

    .date-picker-prefix {
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        height: auto;
        width: 30px;
        background-color: var(--primary-green);
        color: var(--primary-black) !important;
    }

    .date-picker-input {
        padding: 3px 0 3px 3px;
        border: 2px solid var(--primary-light-green);
        border-radius: 5px;
        width: 100%;
        height: 22px;

        &:focus-visible {
            border: 2px solid var(--primary-green) !important;
            outline: none;
        }
    }
}

input[type='date']::-webkit-calendar-picker-indicator {
    background-image: url(../../assets/calendar-month.png);
    height: 32px;
    width: 30px;
    background-color: var(--primary-green);
}
</style>
